
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/naic",
      function () {
        return require("private-next-pages/naic.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/naic"])
      });
    }
  